module.exports = __webpack_public_path__ + "img/icon-sale-report-food.676a6186.png";